import React, { ReactNode } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline, GlobalStyles } from '@mui/material';
import { appTheme, globalStyles, appClasses } from '../appTheme';

interface AppThemeProviderProps {
  children: ReactNode;
  standalone?: boolean; // Pour le développement standalone
}

export const AppThemeProvider: React.FC<AppThemeProviderProps> = ({
  children,
  standalone = false
}) => {
  // Injection des styles globaux si en mode standalone
  React.useEffect(() => {
    if (standalone) {
      const styleElement = document.createElement('style');
      styleElement.textContent = globalStyles;
      document.head.appendChild(styleElement);
      return () => {
        document.head.removeChild(styleElement);
      };
    }
  }, [standalone]);

  return (
    <ThemeProvider theme={appTheme}>
      <CssBaseline />
      <GlobalStyles styles={globalStyles} />
      {children}
    </ThemeProvider>
  );
};

// Hook pour accéder aux classes CSS
export const useAppClasses = () => appClasses;